
<transition name="fade">
  <div
    v-show="showScrollTop"
    class="scroll-top"
    @click="scrollTop"
  >
    <icon name="arrow_upward" />
  </div>
</transition>
